module.exports = __webpack_public_path__ + "img/slide-1.87acfcc2.jpg";